<template>
  <section class="fit">
    <h1>JSON Form Editor</h1>
    <loader></loader>
    <div class="top-button mb-10">
      <form-switch
        :changeView="changeView"
        @switchView="switchView($event)"
      ></form-switch>
      <div>
        <app-button
          v-if="view === EDITOR_VIEW_FORM"
          class="warning"
          @onclick="resetForm()"
        >
          Reset Form
          <tooltip :text="TOOLTIP_TEXT.RESET_FORM"></tooltip>
        </app-button>
        <app-button
          v-if="view === EDITOR_VIEW_FORM"
          @onclick="addComponent()"
        >
          Add Component
          <tooltip :text="TOOLTIP_TEXT.ADD_NEW_COMPONENT"></tooltip>
        </app-button>
      </div>
    </div>
    <div v-if="view == EDITOR_VIEW_RAW">
      <div class="top-button">
        <p>
          {{ PASTE_JSON }}
          <label class="load-file-link" for="load-file">load from file</label>:
        </p>
        <app-button
          v-if="view === EDITOR_VIEW_RAW"
          class="warning"
          @onclick="resetForm()"
        >
          Reset Form
          <tooltip :text="TOOLTIP_TEXT.RESET_FORM"></tooltip>
        </app-button>
      </div>
      <raw-json
        :json="json"
        :root="root"
        @saveRaw="saveJSON($event)"
      ></raw-json>
    </div>
    <form-editor
      v-else
      :json="json"
      :root="root"
      @saveForm="saveJSON($event)"
    ></form-editor>
    <div class="bottom-buttons">
      <div class="bottom-buttons">
        <load-json @loadSampleJSON="loadSampleJSON($event)"></load-json>
        <app-button class="load-file">
          <label for="load-file">
            Load from File
            <tooltip :text="TOOLTIP_TEXT.LOAD_FROM_FILE"></tooltip>
          </label>
          <input 
            type="file" 
            id="load-file" 
            accept="application/JSON" 
            enctype="multipart/form-data" 
            hidden 
            @change="loadFile($event)"
          />
        </app-button>
      </div>
      <button-group
        @export="saveExport()"
        @copy="saveCopy()"
      ></button-group>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import FormSwitch from "../components/FormSwitch.vue";
import RawJSON from "./RawJSON.vue";
import FormEditor from "./FormEditor.vue";
import AppButton from "../components/AppButton.vue";
import ButtonGroup from "../components/ButtonGroup.vue";
import LoadJson from "../components/LoadJson.vue";
import PopUpAlert from "../components/PopUpAlert.vue";
import Tooltip from "../components/Tooltip.vue";
import Loader from "../components/Loader.vue";
import { Bus } from "../main.js";
import { MESSAGES, ALERT_TYPE, ROOT_NODE, TOOLTIP_TEXT } from "../mixins/constant-mixin";

export default {
  name: "home",
  components: {
    "form-switch": FormSwitch,
    "raw-json": RawJSON,
    "form-editor": FormEditor,
    "app-button": AppButton,
    "button-group": ButtonGroup,
    "load-json": LoadJson,
    "pop-up-alert": PopUpAlert,
    "tooltip": Tooltip,
    "loader": Loader,
  },
  data() {
    return {
      EDITOR_VIEW_RAW: MESSAGES.EDITOR_VIEW_RAW,
      EDITOR_VIEW_FORM: MESSAGES.EDITOR_VIEW_FORM,
      PASTE_JSON: MESSAGES.PASTE_JSON,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
      view: MESSAGES.EDITOR_VIEW_RAW,
      json: null,
      root: ROOT_NODE.FIELDS,
      changeView: false,
      invalidJson: false,
    };
  },
  mounted() {
    // emit from ButtonGroup, RawJSON
    Bus.$on("save", () => {
      // if view = raw, save json from raw
      if (this.view == this.EDITOR_VIEW_RAW) {
        Bus.$emit("saveRaw");
      }
      // if view = form, save json from form
      else {
        Bus.$emit("saveForm");
      }
    });

    Bus.$on("openAlert", (message, type) => {
      let PopUpAlertClass = Vue.extend(PopUpAlert);
      let PopUpAlertInstance = new PopUpAlertClass({
        propsData: { messageProp: message, typeProp: type }
      })
      const div = document.createElement("div");
      this.$el.appendChild(div)
      PopUpAlertInstance.$mount(div)
    })
  },
  methods: {
    switchView: function (switchToView) {
      if (switchToView === this.EDITOR_VIEW_RAW) {
        // changed to raw
        Bus.$emit("saveForm");
      } else if (switchToView === this.EDITOR_VIEW_FORM) {
        // changed to form
        Bus.$emit("saveRaw");
      }

      if (this.view === switchToView) {
        return;
      }

      if (this.invalidJson) {
        Bus.$emit("openAlert", MESSAGES.INVALID_JSON, ALERT_TYPE.ERROR);
        Bus.$emit("cancelSwitch");
        return;
      }
      this.view = switchToView;
      this.changeView = !this.changeView;

      Bus.$emit("closeAlert");
    },
    resetForm: function () {
      if (confirm(MESSAGES.RESET_CONFIRMATION)) {
        this.json = null;
        this.root = ROOT_NODE.FIELDS;
        Bus.$emit("loadJSON");
        Bus.$emit("closeAlert");
      }
    },
    addComponent: function () {
      Bus.$emit("addComponent");
    },
    // process when save: 
    // Bus.on('save') at Home.vue
    // emit 'saveRaw' or 'saveForm' to RawJSON or FormEditor
    // RawJson or FormEditor send json string to this saveJSON()
    saveJSON: function (jsonString) {
      try {
        if (!jsonString || jsonString.trim() == "") {
          this.json = null;
        } else {
          const json = JSON.parse(jsonString);
          if (typeof json === 'number') {
            throw "Invalid JSON";
          }
          this.json = json;
          
          if (this.json && this.json[ROOT_NODE.AREAS]) {
            this.root = ROOT_NODE.AREAS;
          } else {
            this.root = ROOT_NODE.FIELDS;
          }
        }
      } catch (e) {
        this.invalidJson = true;
        return false;
      }
      this.invalidJson = false;
      if (this.json && this.json[this.root]) {
        this.json[this.root].sort(
          (f1, f2) => parseInt(f1.layout.seq) - parseInt(f2.layout.seq)
        );
      }
    },
    saveExport: function() {
      Bus.$emit("save");
      const currDate = new Date();
      // ["Thu", "Dec", "22", "2022"]
      const dateArr = currDate.toDateString().split(" ");
      let hour = currDate.getHours();
      if (hour < 10) {
        hour = "0" + hour;
      }
      let minute = currDate.getMinutes();
      if (minute < 10) {
        minute = "0" + minute
      }
      // jfe_export_ddMonYYYY_HH24mi.json
      const fileName = "jfe_export_" +
        dateArr[2] + dateArr[1] + dateArr[3] + "_" +
        hour + minute +
        ".json";
      this.$nextTick(async() => {
        if (this.invalidJson) {
          Bus.$emit("openAlert", MESSAGES.FAILED_DUE_TO_INVALID, ALERT_TYPE.ERROR)
        } else if (this.json) { 
          const jsonStr = JSON.stringify(this.json, null, 2).trim();
          if (window.showSaveFilePicker) {
            const opts = {
              suggestedName: fileName,
              types: [{
                description: "JSON file",
                accept: {"application/json": ".json"}
              }]
            }
            try {
              // create and get the file handle
              const fileHandle = await window.showSaveFilePicker(opts)
              Bus.$emit("loadingStart");
              // create a FileSystemWritableFileStream to write to
              const writable = await fileHandle.createWritable();
              // write the jsonStr to the stream
              await writable.write(jsonStr);
              // close the file and write the content to disk
              await writable.close();
            } catch(err) {
              Bus.$emit("loadingEnd");
              Bus.$emit("openAlert", MESSAGES.EXPORT_FAILED, ALERT_TYPE.ERROR);
              return;
            }
            Bus.$emit("loadingEnd");
            Bus.$emit("openAlert", MESSAGES.EXPORT_SUCCESS, ALERT_TYPE.SUCCESS);
          } else {
            let dataStr =
              "data:text/json; charset=utf-8," +
              encodeURIComponent(jsonStr);
            const downloadAnchor = document.createElement("a");
            downloadAnchor.setAttribute("href", dataStr);
            downloadAnchor.setAttribute("download", fileName);  
            document.body.appendChild(downloadAnchor); // required for firefox
            if (confirm(MESSAGES.EXPORT_CONFIRMATION)) {
              downloadAnchor.click();
            }
            downloadAnchor.remove();
          }
        } else {
          Bus.$emit("openAlert", MESSAGES.EXPORT_NO_CONTENT, ALERT_TYPE.ERROR);
        }
      })
    },
    saveCopy: function() {
      Bus.$emit("save");
      this.$nextTick(() => {
        if (this.invalidJson) {
          Bus.$emit("openAlert", MESSAGES.FAILED_DUE_TO_INVALID, ALERT_TYPE.ERROR)
        } else if (this.json) { 
          const jsonStr = JSON.stringify(this.json, null, 2).trim();
          navigator.clipboard.writeText(jsonStr);
          Bus.$emit("openAlert", MESSAGES.COPY_NOTIFICATION, ALERT_TYPE.SUCCESS);
        } else {
          Bus.$emit("openAlert", MESSAGES.COPY_NO_CONTENT, ALERT_TYPE.ERROR);
        }
      })
    },
    loadSampleJSON: function (form) {
      Bus.$emit("save");
      if ((this.json && Object.keys(this.json).length > 0)) {
        if (!confirm(MESSAGES.LOAD_SAMPLE_CONFIRMATION)) {
          return;
        }
      }
      Bus.$emit("closeAlert");
      this.json = structuredClone(form);
      this.root = form.fields ? ROOT_NODE.FIELDS : ROOT_NODE.AREAS;
      Bus.$emit("loadJSON");
    },
    loadFile: function (event) {
      const reader = new FileReader();
      const file = event.target.files[0];
      if (!file.name.includes(".json")) {
        Bus.$emit("openAlert", MESSAGES.JSON_FILE_TYPE, ALERT_TYPE.ERROR);
        return;
      }
      reader.onload = (res) => {
        if ((this.json && Object.keys(this.json).length > 0)) {
          if (!confirm(MESSAGES.LOAD_JSON_CONFIRMATION)) {
            return;
          }
        }
        this.saveJSON(res.target.result);
        Bus.$emit("loadJSON");
      }
      reader.onerror = (err) => {
        Bus.$emit("openAlert", MESSAGES.INVALID_JSON, ALERT_TYPE.ERROR);
        console.log(err);
      }
      reader.readAsText(file);
      event.target.value = "";
    }
  },
};
</script>

<style scoped>
@media (min-width: 960px) {
  .fit {
    width: 80vw;
    margin: 0 auto;
  }
}

@media (min-width: 1300px) {
  .fit {
    width: 70vw;
    margin: 0 auto;
  }
}

@media (min-width: 1600px) {
  .fit {
    width: 60vw;
    margin: 0 auto;
  }
}

.mb-10 {
  margin-bottom: 10px;
}

.top-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bottom-buttons {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.load-file-link {
  cursor: pointer;
  text-decoration: underline;
  color: #00e;
}

.load-file {
  padding: 0;
}

.load-file label {
  display: block;
  cursor: pointer;
  padding: 12px 16px;
}

.warning {
  background: #b80000;
  color: #fff;
}
</style>

<style>
/* Exisiting Classes */
.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-6 {
  margin-right: 1.5rem;
}

.p-3 {
  padding: 0.75rem;
}

.ql-align-justify {
  text-align: justify;
}
</style>
